<h2 mat-dialog-title class="modal-title">Upgrade to access this feature</h2>
<div
  mat-dialog-content
  class="modal-content"
  [innerHtml]="
    'ONSIP_I18N.YOURE_CURRENTLY_ENROLLED_IN_THE_FREE_BSTARTERB_PLAN_UPGRADE_TO_THE_BPROB_PLAN_FOR_4995MONTH_TO_ACCESS_THIS_FEATURE_AND_MORE'
      | translate
  "
></div>
<div mat-dialog-actions class="modal-actions">
  <button mat-button color="primary" mat-dialog-close>
    {{ "ONSIP_I18N.CANCEL" | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    cdkFocusInitial
    onsipNewCall
    remoteAor="sales@onsip.com"
    mat-dialog-close
  >
    {{ "ONSIP_I18N.SPEAK_TO_AN_AGENT" | translate }}
  </button>
</div>
